import { ActionType } from "./ActionType";

// Initial global state
const InitialData = {
    data: [], // Holds a global list of items
};

export const globalReducer = (state = InitialData, action) => {
    switch (action.type) {
        // Add a list of items
        case ActionType.ADD_LIST: {
            return {
                ...state,
                data: [...state.data, ...action.payload], // Add the new list to the current data
            };
        }

        // Remove items by id
        case ActionType.REMOVE_LIST: {
            return {
                ...state,
                data: [], // Remove items with specified ids
            };
        }

        // Get the list (this just returns the state, no change)
        case ActionType.GET_LIST: {
            return state; // Return the current state (this can be useful for logging or debugging)
        }

        default:
            return state; // Return the current state if action type is unrecognized
    }
};
